import PropTypes from 'prop-types';

import getContentfulImgixUrl from 'utils/getContentfulImgixUrl';
import Section from 'legacy/components/section';
import Flex from 'legacy/components/flex';
import Text from 'legacy/components/text';
import Image from 'legacy/components/image';
import { contentfulImageType } from 'types';

const PressCoverage = ({ heading, logos }) => (
  <Section bg="blue">
    <Section.Inner>
      <Flex flexDirection="column" alignItems="center">
        <Text
          variant={['default', null, null, 'large']}
          color="white"
          textAlign="center"
          fontWeight={600}
        >
          {heading}
        </Text>
        <Flex flexWrap="wrap" justifyContent="center" ml={[0, null, -5]} maxWidth="55rem">
          {logos.map((logo) => (
            <Flex
              key={logo.sys?.id}
              justifyContent="center"
              alignItems="center"
              width={[1, null, 'auto']}
            >
              <Image
                mt={4}
                ml={[0, null, 5]}
                minHeight={logo.height}
                height={logo.height}
                src={getContentfulImgixUrl(logo.image.url)}
                htmlAttributes={{ alt: logo.altText }}
                lazyload
              />
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Section.Inner>
  </Section>
);

PressCoverage.propTypes = {
  heading: PropTypes.string.isRequired,
  logos: PropTypes.arrayOf(contentfulImageType).isRequired,
};

export default PressCoverage;
